import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d42a849e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "asCamera"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-camera" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "asCamera_container"
}
const _hoisted_5 = { class: "asCamera_text" }
const _hoisted_6 = { class: "asCamera_progress" }
const _hoisted_7 = { class: "asCamera_modal" }
const _hoisted_8 = {
  key: 0,
  class: "asCamera_modal_choose-type"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-photo" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-video" }, null, -1))
const _hoisted_11 = { class: "asCamera_modal_videoWrapper" }
const _hoisted_12 = { class: "asCamera_modal_actions" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_video_record = _resolveComponent("as-video-record")!
  const _component_as_modal = _resolveComponent("as-modal")!

  return (_ctx.hasGetUserMedia)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.status === 'start' || _ctx.status !== 'sending')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "asCamera_openModal",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
            }, _hoisted_3))
          : (_ctx.status === 'sending')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('uploadFile')) + " (" + _toDisplayString(_ctx.progress) + "%)", 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    style: _normalizeStyle({ width: `${_ctx.progress}%` }),
                    class: "asCamera_fill"
                  }, null, 4)
                ])
              ]))
            : _createCommentVNode("", true),
        _createVNode(_component_as_modal, {
          modelValue: _ctx.modal.show,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modal.show) = $event)),
          title: _ctx.titleText,
          btnClose: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.localType !== 'video' && _ctx.localType !== 'image')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "asCamera_button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.localType = 'image'))
                    }, [
                      _hoisted_9,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('Take photo')), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "asCamera_button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.localType = 'video'))
                    }, [
                      _hoisted_10,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('Take video')), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.modal.show)
                        ? (_openBlock(), _createBlock(_component_as_video_record, {
                            key: 0,
                            type: _ctx.localType,
                            onRecordedData: _cache[3] || (_cache[3] = ($event: any) => (_ctx.data = $event))
                          }, null, 8, ["type"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["asCamera_button", {
              '-disabled': !_ctx.data
              }]),
                        disabled: !_ctx.data,
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendRecordData && _ctx.sendRecordData(...args)))
                      }, _toDisplayString(_ctx.$t('send')), 11, _hoisted_13)
                    ])
                  ], 64))
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ]))
    : _createCommentVNode("", true)
}